export const LIVE_REFRESH_INTERVAL_MS = 5 * 60_000;
export const LIVE_REFRESH_INTERVAL_SECONDS = LIVE_REFRESH_INTERVAL_MS / 1_000;
export const LIVE_REFRESH_INTERVAL_MINUTES = LIVE_REFRESH_INTERVAL_MS / 60_000;
export const HEADER_REFRESH_INTERVAL_MS = 10 * 60_000;
export const FIRETEAM_ACTIVITY_REFRESH_INTERVAL_MS = 60_000;
